import React from 'react'
import { useTranslation } from 'react-i18next'
import { BeWizrCourse } from '~/models'
import { bewizrCoursesStore } from '~/stores'
import { observer } from '~/ui/component'
import { EmptyOrFetching, Scroller } from '~/ui/components'
import { AppLayoutConfig } from '~/ui/layouts'
import { layout } from '~/ui/styling'
import BeWizrGrid from '../bewizr/BeWizrGrid'
import BeWizrCourseTile from './BeWizrCourseTile'

export interface Props {

}

const BeWizrReadOnlyCoursesScreen = observer('BeWizrReadOnlyCoursesScreen', (props: Props) => {

  const [t] = useTranslation('bewizr-courses')

  const endpoint = bewizrCoursesStore.readonlyCourses

  const fetch = React.useCallback(() => {
    endpoint.fetch()
  }, [endpoint])

  React.useEffect(() => {
    fetch()
  }, [fetch])

  const fetchStatus = endpoint.fetchStatus
  const empty       = fetchStatus !== 'done' || endpoint.empty

  //------
  // Rendering

  function render() {
    return (
      <>
        <AppLayoutConfig
          title={t('readonly')}
          fetchStatus={fetchStatus}
        />
        {empty ? renderEmpty() : renderBody()}
      </>
    )
  }

  function renderEmpty() {
    return (
      <EmptyOrFetching
        {...t('empty.readonly')}
        status={fetchStatus}
        flex
      />
    )
  }

  function renderBody() {
    return (
      <Scroller contentPadding={layout.padding.m}>
        <BeWizrGrid
          endpoint={endpoint}
          renderItem={renderCourse}
        />
      </Scroller>
    )
  }

  function renderCourse(course: BeWizrCourse) {
    return (
      <BeWizrCourseTile
        title={course.title}
        slug={course.slug}
        image={course.links.image}
        progress={false}
      />
    )
  }

  return render()

})

export default BeWizrReadOnlyCoursesScreen